import React from "react";
import ConfProduct from "../../../components/DetailListView/ConfProduct";
import SimpleProduct from "../../../components/DetailListView/SimpleProduct";
import { PRODUCT_TYPE_CONFIGURABLE } from "../../../constants/common";

export default function RecommendedForMathClassSection({ groupOrder, name, refSection}) {
  const { items } = groupOrder;
  const recommendedItems = items.filter(
    (item) => item.is_add_more_product_when_go_is_no_calculator
  );

  if (recommendedItems.length > 0)
    return (
      <div className="recommended-for-math-class-section section-scroll-offset" ref={refSection}>
        <h3 className="pt-6 text-lg font-medium md:text-xl text-gunmetal-black-500">{name}</h3>
        <div className="grid grid-cols-1 py-4 gap-y-4 md:gap-y-6 lg:gap-y-8">
          {recommendedItems.map((product) =>
            product.product_type === PRODUCT_TYPE_CONFIGURABLE ? (
              <ConfProduct
                key={product.product_id}
                item={product}
              />
            ) : (
              <SimpleProduct
                key={product.product_id}
                item={product}
              />
            )
          )}
        </div>
      </div>
    );

  return "";
}
